import { render } from "./EducationPage.vue?vue&type=template&id=dfaea0a2"
import script from "./EducationPage.vue?vue&type=script&lang=js"
export * from "./EducationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__